module.exports = __webpack_public_path__ + "img/ic_expense_deleted.c8264274.png";